module.exports = __webpack_public_path__ + "img/img10.967909d2.jpg";